import { useSelector } from "react-redux";
import "./style.scss";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { RootState } from "@/src/store";
import { useEffect } from "react";
import { createPortal } from "react-dom";

type PreloyderMode = "fullscreen" | "content";

interface PreloyderProps {
  mode?: PreloyderMode;
}

const Preloyder = ({ mode = "fullscreen" }: PreloyderProps) => {
  const { isPreloyder } = useSelector((state: RootState) => state.Preloyder);
  const isFullscreen = mode === "fullscreen";

  useEffect(() => {
    const body = document.body;
    if (isPreloyder && isFullscreen) {
      body.classList.add("hidden");
    } else {
      body.classList.remove("hidden");
    }
    return () => {
      body.classList.remove("hidden");
    };
  }, [isPreloyder, isFullscreen]);

  const preloyderNode = (
    <div className={`preloyder ${isFullscreen ? "" : "preloyder--content"}`.trim()}>
      <div className="preloyder-content">
        <DotLottieReact src="https://lottie.host/3e332524-2b37-4ec5-9c5b-995d85d5aecf/HS52V89q0z.lottie" loop autoplay />
      </div>
    </div>
  );

  if (!isFullscreen) {
    return preloyderNode;
  }

  return createPortal(preloyderNode, document.body);
};

export default Preloyder;
